/*
 * COMBASEアカウントログイン誘導ページ (WEB-1371)
 *
 * クエリの handle を元に AJAX(/products/{handle}.js)で商品情報を取得し、
 * 商品カードを描画する。また「新規登録・ログイン」ボタンの遷移先に、元の
 * 商品ページへ戻る redirect_to パラメータを付与する。
 */
(function () {
  "use strict";

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function formatMoney(cents) {
    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "JPY";
    try {
      return new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol",
      }).format(cents / 100);
    } catch (e) {
      return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
    }
  }

  function renderProduct(product) {
    var wrap = document.getElementById("FcLoginProduct");
    if (!wrap) return;

    var img = document.getElementById("FcLoginProductImage");
    if (img && product.featured_image) {
      img.src = product.featured_image;
      img.alt = product.title || "";
    }

    var name = document.getElementById("FcLoginProductName");
    if (name) name.textContent = product.title || "";

    var price = document.getElementById("FcLoginProductPrice");
    if (price) price.textContent = formatMoney(product.price);

    // 全商品がCOMBASE会員限定のため、ラベルは常に表示する
    var label = document.getElementById("FcLoginProductLabel");
    if (label) label.hidden = false;

    wrap.hidden = false;
  }

  function setCtaHref(handle) {
    var cta = document.getElementById("FcLoginCta");
    if (!cta) return;

    var base = cta.dataset.fcLoginUrl;
    if (!base) return;

    // ログイン後に元の商品ページ(なければトップ)へ戻す
    var redirectBack = handle
      ? window.location.origin + "/products/" + handle
      : window.location.origin;

    var separator = base.indexOf("?") === -1 ? "?" : "&";
    cta.href =
      base + separator + "redirect_to=" + encodeURIComponent(redirectBack);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var handle = getParam("handle") || getParam("product_handle");

    setCtaHref(handle);

    if (!handle) return; // handle が無い場合は商品カードを表示しない

    fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (product) renderProduct(product);
      })
      .catch(function () {
        /* 取得失敗時は商品カード非表示のまま(誘導自体は継続) */
      });
  });
})();
